import error404Bg from '@assets/error-404-bg.png';
import error404Illustration from '@assets/error-404-image.png';
import { ErrorPage } from '@components/ui/organisms/ErrorPage';
import errorTracker from '@shared/errorTracking/errorTracker';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Error404PageProps = {
  /** Which code path rendered the 404, so occurrences can be told apart in Sentry. */
  source?: 'catch-all' | 'uuid-guard' | 'quickpay-guard';
  /** Extra context for Sentry, e.g. the invalid param value that triggered a guard. */
  detail?: string;
};

export const Error404Page: React.FC<Error404PageProps> = ({ source = 'catch-all', detail }) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const error = new Error(
      `404 rendered [${source}] at ${pathname}${search}${detail ? ` (${detail})` : ''}`
    );

    error.name = 'RouteNotFoundError';
    errorTracker.captureException(error);
  }, [source, detail, pathname, search]);

  return (
    <ErrorPage
      bgImage={error404Bg}
      illustration={error404Illustration}
      title="404 Not Found!"
      subtitle="Page not found."
      description={`It might be hidden, moved, or never existed in the first place.
Let's get you back on track!`}
      errorCode="404"
    />
  );
};

Error404Page.displayName = 'Error404Page';
